import template from "./kiosk_pairing.html";
import en from "./en.json";
import es from "./es.json";
import logoUrl from "../../../../../assets/harvust-logo-008.svg";
import { kioskState } from "../../../../base.routes";
import mixpanel from "mixpanel-browser";

class KioskPairingController {
    /* @ngInject */
    constructor(KioskService, AuthService, $state, $location) {
        this.KioskService = KioskService;
        this.AuthService = AuthService;
        this.$state = $state;
        this.$location = $location;
        this.logoUrl = logoUrl;
    }

    $onInit() {
        let ctrl = this;
        ctrl.KioskService.stopInactivityLogout();
        ctrl.AuthService.clearStorage();
        ctrl.code = ctrl.pairingCode;
        if (ctrl.code) {
            ctrl.$location.search("pairing_code", null).hash("").replace();
            return ctrl.pair();
        }
        ctrl.error = "kioskPairing.MISSING_QR";
    }

    pair() {
        let ctrl = this;
        if (ctrl.pairing || ctrl.destroyed) {
            return;
        }
        ctrl.pairing = true;
        ctrl.error = undefined;
        return ctrl.KioskService.pair(ctrl.code)
            .then(function (kiosk) {
                if (!ctrl.destroyed) {
                    mixpanel.track("Paired kiosk", {
                        company_sid: kiosk.grower_organization,
                        kiosk_sid: kiosk.sid,
                    });
                    ctrl.$state.go(
                        kioskState,
                        { kiosk_sid: kiosk.sid },
                        { location: "replace" },
                    );
                }
            })
            .catch(function () {
                if (!ctrl.destroyed) {
                    ctrl.error = "kioskPairing.ERROR";
                }
            })
            .finally(function () {
                if (!ctrl.destroyed) {
                    ctrl.pairing = false;
                }
            });
    }

    $onDestroy() {
        let ctrl = this;
        ctrl.destroyed = true;
    }
}

export default {
    name: "kioskPairing",
    controller: KioskPairingController,
    template,
    bindings: { pairingCode: "<" },
    translations: { en, es },
};
